import { FlashMessageGenerateTokenDto } from "../../../dto/flashmessagegenereratetoken/flashmessagegeneratetoken";
import { APIRequest, APIRequestDtoImpl } from "../../apiRequest";


export interface RewardPointGenerateTokenRequest extends APIRequest
{
    getRewardPointGenerateTokenRequest(): FlashMessageGenerateTokenDto;
}

export class RewardPointGenerateTokenRequestImpl extends APIRequestDtoImpl implements RewardPointGenerateTokenRequest
{
    constructor(private tokenDto: FlashMessageGenerateTokenDto)
    {
        super();
    }

    getRewardPointGenerateTokenRequest(): FlashMessageGenerateTokenDto
    {
        return this.tokenDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenrequest.tsx